export default __webpack_public_path__ + "static/custom-a5615bc495149ee99025e4c3ec702717.png";